import { render, staticRenderFns } from "./STAR.vue?vue&type=template&id=6548ea8b&"
import script from "./STAR.vue?vue&type=script&lang=js&"
export * from "./STAR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports